module.exports = __webpack_public_path__ + "static/media/lock_blue.76a053eb.svg";